import React, { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";

const LoginPage = () => {
  const [usuario, setUsuario] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [mensaje, setMensaje] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // No forzar HTTPS en localhost para desarrollo
    const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    if (!isLocal && window.location.protocol !== "https:") {
      const httpsUrl = `https://${window.location.hostname}${window.location.pathname}${window.location.search}`;
      window.location.replace(httpsUrl);
      return;
    }

    const storedUsername = localStorage.getItem("username");
    if (storedUsername) setUsername(storedUsername);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje("");
    const configured = (process.env.REACT_APP_LOGIN_URL || "").trim().replace(/\/$/, "");
    const endpoints = Array.from(
      new Set(
        [
          configured,
          "https://www.institutosilvianocarrillo.com/login",
          "https://institutosilvianocarrillo.com/login",
        ].filter(Boolean)
      )
    );

    let lastError = "";

    for (const endpoint of endpoints) {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 7000);

      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Usuario: usuario, Contrasena: contrasena }),
          signal: controller.signal,
        });
        clearTimeout(timeoutId);

        const contentType = res.headers.get("content-type") || "";
        const isJson = contentType.includes("application/json");
        const data = isJson ? await res.json().catch(() => null) : null;

        if (!res.ok) {
          const msg = (data && data.message) || "Usuario o contraseña incorrectos";
          setMensaje(msg);
          if (res.status >= 400 && res.status < 500) return; // Respuesta definitiva
          lastError = msg;
          continue;
        }

        if (!isJson || !data || typeof data.role === "undefined") {
          lastError = "Respuesta inesperada del servidor.";
          continue;
        }

        if (data.token) localStorage.setItem("token", data.token);
        if (data.role !== undefined) localStorage.setItem("role", String(data.role));
        localStorage.setItem("displayName", data.displayName || data.username || "Usuario");
        if (data.username) localStorage.setItem("username", data.username);
        if (data.idUsuario) localStorage.setItem("idUsuario", String(data.idUsuario));

        setMensaje(data.message || "Inicio de sesión correcto");

        const roleNumber = Number(data.role);
        switch (roleNumber) {
          case 1:
            navigate("/directora");
            break;
          case 2:
            navigate("/coordinadora");
            break;
          case 3:
            navigate("/docente");
            break;
          case 4:
            navigate("/alumno");
            break;
          default:
            navigate("/");
        }
        return;
      } catch (err) {
        clearTimeout(timeoutId);
        console.warn(`Intento fallido en ${endpoint}:`, err);
        lastError = err.name === "AbortError" ? "Tiempo de espera agotado" : "No se pudo contactar al servidor. Intenta nuevamente.";
      }
    }

    setMensaje(lastError || "No se pudo contactar al servidor. Intenta nuevamente.");
  };

  const togglePasswordVisibility = () => setShowPassword((v) => !v);

  return (
    <div className="login-container">
      <div className="login-right">
        <h3>Bienvenido</h3>
        {username ? <h4>Hola de nuevo, {username}!</h4> : <small>Nos da gusto verte aquí</small>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="usuario">Usuario</label>
            <input
              type="text"
              id="usuario"
              className="form-control"
              placeholder="Introduce tu usuario"
              required
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="contrasena">Contraseña</label>
            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                id="contrasena"
                className="form-control"
                placeholder="Introduce tu contraseña"
                required
                value={contrasena}
                onChange={(e) => setContrasena(e.target.value)}
                maxLength={80}
              />
              <span onClick={togglePasswordVisibility} className="password-toggle">
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>

          <button type="submit" className="btn-login">
            Iniciar sesión
          </button>
        </form>

        {mensaje && <p className="login-message">{mensaje}</p>}
      </div>

      <div className="login-left">
        <img src="images/logo.png" alt="Logo" />
        <h2>Instituto Silviano Carrillo</h2>
      </div>
    </div>
  );
};

export default LoginPage;